module.exports = __webpack_public_path__ + "img/colleVideo.fa5e12c3.svg";